// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1__MU","cls2":"ProfilePdfPackCard-cls2_PGs ProfilePdfPackCard-cls1__MU"};